import { useMutation } from '@vue/apollo-composable';
import gql from 'graphql-tag';
import useAlerts from './useAlerts';

const { addAlert } = useAlerts();

const ADD_CONTACT_MUTATION = gql`
  mutation AddContactMutation($contact: TBL_CONTACT_Input) {
    addContact(contact: $contact)
  }
`;

const UPDATE_CONTACT_MUTATION = gql`
  mutation UpdateContactMutation($contactid: ID!, $contact: TBL_CONTACT_Input) {
    updateContact(CONTACTID: $contactid, contact: $contact)
  }
`;

const DELETE_CONTACT_MUTATION = gql`
  mutation DeleteContactMutation($contactid: ID!) {
    deleteContact(CONTACTID: $contactid)
  }
`;

export default function useContactMutate() {
  const { mutate: addMutate } = useMutation(ADD_CONTACT_MUTATION);
  const { mutate: updateMutate } = useMutation(UPDATE_CONTACT_MUTATION);
  const { mutate: deleteMutate } = useMutation(DELETE_CONTACT_MUTATION);

  async function addContact(contact) {
    try {
      const { data } = await addMutate({ contact });
      return data;
    } catch (error) {
      console.error('Error adding new contact:', error);
      addAlert('Error adding new contact', 'high', 4);
      throw error;
    }
  }

  async function updateContact(contactid, contact) {
    try {
      const { data } = await updateMutate({ contactid, contact });
      return data;
    } catch (error) {
      console.error('Error updating contact:', error);
      addAlert('Error updating contact', 'high', 4);
      throw error;
    }
  }

  async function deleteContact(contactid) {
    try {
      const { data } = await deleteMutate({ contactid });
      return data;
    } catch (error) {
      console.error('Error deleting contact:', error);
      addAlert('Error deleting contact', 'high', 4);
      throw error;
    }
  }

  return {
    addContact,
    updateContact,
    deleteContact,
  };
}
